import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {
  displayContentUiPreReqSchema,displayContentJsonSchema
} from '@/services/schema/displayContentSchema'

export const DisplayPreReqContentTab = ({
  formData,
  setFormData,
  languages,
}) => {
  const handleChange = (langCode, updatedLangData) => {
    const updatedFormData = {
      ...formData,
      [langCode]: updatedLangData
    }
    setFormData(updatedFormData)
  }

  return (
    <div className={`grid grid-cols-2`}>
      {languages?.map((lang) => (
        <div key={lang.code} className="col-span-1 w-full max-w-full overflow-hidden p-2">
          <h3 className="text-lg font-semibold mb-4 text-white">{lang.title}</h3>
          <JsonFormsWrapper
            jsonschema={displayContentJsonSchema}
            uischema={displayContentUiPreReqSchema}
            data={formData?.[lang.code] || {}}
            onChange={data => handleChange(lang.code, data)}
          />
        </div>
      ))}
    </div>
  )
}
